<form [formGroup]="form">
  <div formArrayName="skills">
    <div *ngFor="let skill of skills.controls; let i = index">
      <div [formGroupName]="i" class="form-row align-items-center">
        <div class="form-group col-md-6">
          <input type="text" class="form-control" placeholder="MS-Word" formControlName="title">
        </div>
        <div class="form-group col-md-5">
          <input type="number" class="form-control" placeholder="70%" formControlName="level">
        </div>
        <div class="form-group col-md-1 mt-1 text-center">
          <a *ngIf="canAdd(i)" class="mt-3 mr-2" [routerLink]="" (click)="add()"><i class="fas fa-plus"></i></a>
          <a *ngIf="!canAdd(i)" class="mt-3 mr-2" [routerLink]="" (click)="remove(i)"><i class="far fa-trash-alt text-danger"></i></a>
        </div>
      </div>
    </div>
  </div>
</form>